import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getKarmaMe, getKarmaByUser } from "@/services/rewards.service";
import { Sparkles, Medal } from "lucide-react";

const tierColor = (tier) => {
  if (tier === "Gold") return "bg-amber-100 text-amber-800 border-amber-200 dark:bg-amber-900/40 dark:text-amber-200 dark:border-amber-900/60";
  if (tier === "Silver") return "bg-slate-100 text-slate-700 border-slate-200 dark:bg-slate-800 dark:text-slate-100 dark:border-slate-700";
  return "bg-orange-100 text-orange-800 border-orange-200 dark:bg-orange-900/40 dark:text-orange-200 dark:border-orange-900/60";
};

const KarmaBadge = ({ userId = "me", compact = false, asLink = true, className = "" }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    let cancel = false;
    (async () => {
      try {
        const res = userId === "me" ? await getKarmaMe() : await getKarmaByUser(userId);
        if (!cancel) setData(res);
      } catch {}
    })();
    return () => { cancel = true; };
  }, [userId]);

  if (!data) return null;
  const { balance, tier } = data;
  const styles = tierColor(tier);

  const body = (
    <>
      <Medal className="w-3.5 h-3.5" />
      <span className="font-bold">{balance}</span>
      <span className="opacity-80">Karma</span>
      <span className="opacity-60">·</span>
      <span className="font-semibold">{tier}</span>
    </>
  );

  if (compact) {
    return (
      <span
        data-testid={`karma-badge-${userId}`}
        title={`${balance} Karma · ${tier}`}
        className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-semibold border ${styles} ${className}`}
      >
        <Sparkles className="w-3 h-3" />
        {balance}
        <span className="opacity-80">· {tier}</span>
      </span>
    );
  }

  const inner = (
    <span
      data-testid={`karma-card-${userId}`}
      className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-semibold border transition-colors ${styles} ${asLink ? "hover:bg-background/40" : ""} ${className}`}
    >
      {body}
    </span>
  );

  return asLink && userId === "me" ? <Link to="/rewards">{inner}</Link> : inner;
};

export default KarmaBadge;
